<input type="text" name="location" class="place" [ngModel]="place" #locationInput />

<app-button-group [options]="radiusOptions" [selected]="selectedRadius" [id]="'radius'"
  (change)="selectRadius($event)"></app-button-group>

<map-view *ngIf="place && lat && lng" [latitude]="lat" [longitude]="lng">
  <map-circle #radiusCircle [latitude]="lat" [longitude]="lng" [radius]="radiusMeters"></map-circle>
</map-view>
